import Axios from 'axios';
import { objectToCamel, objectToSnake } from 'ts-case-convert';

export const AXIOS_INSTANCE = Axios.create({
  baseURL: process.env.VITE_APP_URI,
});

type CustomClient<T> = (request: {
  url: string;
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  headers?: Record<string, string>;
  data?: BodyType<object>;
  signal?: AbortSignal;
}) => Promise<T>;

export const useCustomClient = <T>(): CustomClient<T> => {
  return async ({ url, method, headers, data, signal }) => {
    const token = localStorage.getItem('token');

    const response = await AXIOS_INSTANCE.request({
      url,
      method,
      headers: {
        ...headers,
        ...(token && { Authorization: `Bearer ${token}` }),
      },
      data: data && objectToSnake(data),
      signal,
    });

    // SAFETY: the generated T is the camelCase rewrite (case-transformer.js) of the snake_case JSON the endpoint returns.
    return objectToCamel(response.data) as T;
  };
};

export default useCustomClient;

export type ErrorType<ErrorData> = ErrorData;

export type BodyType<BodyData> = BodyData & { headers?: any };
